import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Button, IconButton, Tooltip } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { removeCreative } from "../../actions/app/creatives";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper
  },
  listItem: {
    wordBreak: "break-all"
  },
  copyButton: {
    flexShrink: 0,
    marginLeft: 10
  },
  button: {
    marginRight: 12
  }
}));

export default function GeneratedName({ creative }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [copied, setCopied] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const copyToClipboard = (index) => {
    setCopied(true);
    handleTooltipOpen(index);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
    setTimeout(() => setOpen(false), 1000);
  };

  return (
    <>
      <CopyToClipboard
        onCopy={copyToClipboard}
        text={creative.taxonomy.name ? creative.taxonomy.name : "»»»»»»»»»»»»"}
      >
        <Tooltip
          PopperProps={{
            disablePortal: true
          }}
          onClose={handleTooltipClose}
          open={open}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          title="Name copied"
        >
          <Button
            variant="outlined"
            color="primary"
            className={classes.copyButton}
            disableElevation
          >
            Copy name
          </Button>
        </Tooltip>
      </CopyToClipboard>
      <IconButton
        className={classes.icon}
        onClick={() => dispatch(removeCreative(creative.id))}
      >
        <CancelIcon filled="true" color="action" />
      </IconButton>
    </>
  );
}
